import { themed } from '@heathmont/moon-utils';
import styled from 'styled-components';
import getFontSize from '../private/text/getFontSize';
const Text = styled.p(({ color, theme }) => ({
    color: themed('color', color)(theme),
}), ({ size = 16 }) => getFontSize(size), ({ isBold, theme: { fontWeight } }) => isBold && {
    fontWeight: fontWeight.semibold,
});
Text.defaultProps = {
    color: 'bulma.100',
    size: 16,
};
export default Text;
